module.exports = __webpack_public_path__ + "static/media/icon_notice.fd8424df.svg";